import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from "./user.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(private location: Location, private http: HttpClient, private userService: UserService) { }

  // getCustomers() {
  //   const currentUrl = this.location.path(true);
  //   const findAPIKey = currentUrl.match(/(&|\?)apiKey=(.*)(&|$)/);
  //   if (!findAPIKey || !findAPIKey[2]) return EMPTY;

  //   const url = `http://localhost:3000/api/customers?apiKey=${findAPIKey[2]}`;
  //   return this.http.post(url, null);
  // }
  getCustomer() {
    const url = `/api/customers/${this.userService.customer}?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, null);
  }
}
